import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Box, Chip, Typography } from '@mui/material';
import { lightPalette } from '../../../theme';
import { getOrganizationPlanDetails } from '../../../services/adminDashboard';

const PlanDetailsDashboard = () => {
  const user = useSelector((state) => state.user.user);

  const [planData, setPlanData] = useState({
    planStatus: '',
    planName: '',
  });

  const getPlanData = async () => {
    if (user?.organization_id) {
      const response = await getOrganizationPlanDetails(
        {},
        '',
        {},
        user?.organization_id,
      );
      if (response?.length > 0) {
        setPlanData({
          planStatus: response[0]?.status,
          planName: response[0]?.pricingPlan?.name,
        });
      }
    } else {
      setPlanData({
        planStatus: '',
        planName: '',
      });
    }
  };

  useEffect(() => {
    getPlanData();
  }, [user]);
  return (
    planData?.planName !== '' &&
    planData?.planStatus !== '' && (
      <Chip
        sx={{
          backgroundColor:
            planData?.planStatus === 'active'
              ? lightPalette.freshGreen.lightest
              : lightPalette.fieryRose.lightest,
          border: `1px solid ${
            planData?.planStatus === 'active'
              ? lightPalette.freshGreen.lighter
              : lightPalette.fieryRose.lighter
          }`,
          marginLeft: '12px',
        }}
        label={
          <Box display="flex" alignItems="center">
            <Box
              sx={{
                width: '12px',
                height: '12px',
                borderRadius: '50%',
                marginRight: '8px',
                backgroundColor:
                  planData?.planStatus === 'active'
                    ? lightPalette.freshGreen.main
                    : lightPalette.fieryRose.main,
              }}
            />
            <Typography
              variant="subtitle1"
              color={lightPalette.darkPurple.semiDark}
            >
              {planData?.planStatus === 'active' ? 'Active' : 'Inactive'}
              :&nbsp;
            </Typography>
            <Typography
              variant="subtitle1"
              color={lightPalette.darkPurple.semiDark}
              fontWeight="500"
            >
              {planData?.planName} Plan
            </Typography>
          </Box>
        }
      />
    )
  );
};

export default PlanDetailsDashboard;
